import { type Node, type NodeProps, Position } from '@xyflow/react';
import React from 'react';

import { createHandleId } from '../../utils/handle-ids';
import { BaseNode, type NodeData } from './BaseNode';
import { NodeHandle } from './NodeHandle';

export type TextSplitterNodeType = Node<NodeData, 'custom_text_splitter'>;

export const TextSplitterNode: React.FC<NodeProps<TextSplitterNodeType>> = ({
  id,
  data,
  selected,
}) => {
  const chunkSize = data.config?.chunk_size as number;
  const chunkOverlap = data.config?.chunk_overlap as number;

  let subtitle: string | undefined;
  if (chunkSize !== undefined) {
    subtitle = `${chunkSize} chars`;
    if (chunkOverlap !== undefined) {
      subtitle += ` (overlap: ${chunkOverlap})`;
    }
  }

  // Extract connection state from node data for visual indicators
  const activeConnection = data.activeConnection;
  const isValidTargetHandle = data.isValidTargetHandle as
    | ((targetHandle: string) => boolean)
    | undefined;
  const isActiveConnection = !!activeConnection;

  return (
    <BaseNode
      nodeId={id}
      data={data}
      category="transform"
      subtitle={subtitle}
      selected={selected}
    >
      {/* Input handle with connection indicators */}
      <NodeHandle
        type="target"
        position={Position.Left}
        id="text"
        blockId={id}
        isActiveConnection={isActiveConnection}
        isValidTarget={
          isValidTargetHandle
            ? isValidTargetHandle(createHandleId(id, 'text'))
            : undefined
        }
      />
      {/* Output handle */}
      <NodeHandle
        type="source"
        position={Position.Right}
        id="chunks"
        blockId={id}
        isActiveConnection={isActiveConnection}
      />
    </BaseNode>
  );
};
